import { Component, OnInit, input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { History } from 'src/app/interfaces';
import { dataStoreSignal } from 'src/app/app.component';
import { MatCard, MatCardHeader, MatCardTitle, MatCardContent } from '@angular/material/card';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import {
  MatTable,
  MatHeaderRowDef,
  MatHeaderRow,
  MatRowDef,
  MatRow,
  MatColumnDef,
  MatHeaderCellDef,
  MatHeaderCell,
  MatCellDef,
  MatCell,
} from '@angular/material/table';
import { DatePipe } from '@angular/common';
import { EditPaymentPlanComponent } from '../../dialogs/edit-payment-plan/edit-payment-plan.component';
@Component({
  selector: 'app-balance',
  templateUrl: './balance.component.html',
  styleUrls: ['./balance.component.scss'],
  imports: [
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatCardContent,
    MatIconButton,
    MatTooltip,
    MatIcon,
    MatTable,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    DatePipe,
  ],
})
export class BalanceComponent implements OnInit {
  orgUserHistory = input<History[]>([]);
  ds = dataStoreSignal;
  displayedColumns: string[] = ['credits', 'description', 'date'];

  constructor(
    public dialog: MatDialog,
    public router: Router,
  ) {}

  ngOnInit(): void {}

  async editPlan() {
    this.dialog.open(EditPaymentPlanComponent, {
      width: '450px',
      autoFocus: false,
    });
  }
}
